<form (ngSubmit)="onSubmit()" [formGroup]="formGroup">
  <h2 mat-dialog-title>
    @if (isEditing()) {
      <ng-container i18n="@@purchase-item-dialog-edit-title">Edit purchase order item</ng-container>
    } @else {
      <ng-container i18n="@@purchase-item-dialog-add-title">Add purchase order item</ng-container>
    }
  </h2>
  @if (isLoading()) {
    <app-loader containerClass="on-dialog"></app-loader>
  } @else {
    <mat-dialog-content>
      <div class="row-container">
        <div class="row row-2">
          <div class="item">
            <app-input
              formControlName="lineItemId"
              [label]="translations.item"
              suffixIcon="autorenew"
              [suffixIconTp]="translations.suffixIconTp"
              (suffixIconPressed)="generateItemNumber()"
            ></app-input>
          </div>
          <div class="item">
            <app-input-select
              [options]="allProductsOptions()"
              formControlName="product"
              [label]="translations.product"
            ></app-input-select>
          </div>

          <div class="item">
            <app-input-select
              [options]="unitOfMeasurementOptions()"
              formControlName="unit"
              [label]="translations.unit"
            ></app-input-select>
          </div>
          <div class="item">
            <app-input
              [hint]="
                formGroup.controls['quantity'].value &&
                itemDefaultUnit()?.id !== baseUnitOfMeasurement()?.id
                  ? (formGroup.controls['quantity'].value
                    | unitConversion: itemDefaultUnit() : baseUnitOfMeasurement())
                  : ''
              "
              [suffix]="itemDefaultUnit()?.symbol"
              formControlName="quantity"
              [label]="translations.quantity"
              type="number"
            ></app-input>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <app-button-group>
        <app-button (pressed)="onClose(false)" type="ghost">Cancel</app-button>
        <app-button accessibilityRole="submit" [disabled]="isSubmitButtonDisabled">
          <mat-icon icon-left>check</mat-icon>
          <ng-container i18n="@@action.save">Save</ng-container>
        </app-button>
      </app-button-group>
    </mat-dialog-actions>
  }
</form>
